import NewServiceCard from './NewServiceCard';

export default NewServiceCard;
